import { createSlice } from '@reduxjs/toolkit'

import { completePaypalPaymentMethodChange } from 'features/billing/actions/complete_paypal_payment_method_change'
import { updateCreditCard } from 'features/billing/actions/update_credit_card'
import { updatePaymentInfo } from 'features/billing/actions/update_payment_info'

const initialState = {
  status: 'initial',
  error: null
}

const extractErrorMessage = (payload) => {
  if (!payload) return null
  if (typeof payload === 'string') return payload
  if (payload instanceof Error) return payload.message
  if (typeof payload.message === 'string') return payload.message
  if (typeof payload.error === 'string') return payload.error
  return null
}

const changeCreditCardModalSlice = createSlice({
  name: 'changeCreditCardModal',
  initialState,
  reducers: {
    setError: (state, action) => {
      state.status = 'initial'
      state.error = action.payload.message
    },
    setPending: (state) => { state.status = 'pending' },
    reset: () => initialState
  },
  extraReducers: (builder) => {
    builder.addCase(updateCreditCard.pending, (state) => {
      state.status = 'pending'
    })
    builder.addCase(updateCreditCard.fulfilled, (state) => {
      state.status = 'completed'
      state.error = null
    })
    builder.addCase(updateCreditCard.rejected, (state, action) => {
      state.status = 'completed'
      state.error = extractErrorMessage(action.payload) ?? action.payload
    })
    builder.addCase(updatePaymentInfo.pending, (state) => {
      state.status = 'pending'
    })
    builder.addCase(updatePaymentInfo.fulfilled, (state) => {
      state.status = 'completed'
      state.error = null
    })
    builder.addCase(updatePaymentInfo.rejected, (state, action) => {
      state.status = 'completed'
      state.error = extractErrorMessage(action.payload) ?? action.payload
    })
    builder.addCase(completePaypalPaymentMethodChange.pending, (state) => {
      state.status = 'pending'
    })
    builder.addCase(completePaypalPaymentMethodChange.fulfilled, (state) => {
      state.status = 'completed'
      state.error = null
    })
    builder.addCase(completePaypalPaymentMethodChange.rejected, (state, action) => {
      state.status = 'initial'
      state.error = extractErrorMessage(action.payload) ?? action.payload
    })
  }
})

export const {
  reducer,
  actions: {
    setError,
    setPending,
    reset
  }
} = changeCreditCardModalSlice
